/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const OrganizationSettings = Loadable(lazy(() => import("sections/settings/organization")));
const OrganizationDomains = Loadable(lazy(() => import("sections/settings/domains")));
const UsersSettings = Loadable(lazy(() => import("sections/settings/users")));

const settingsRoutes = [
    {
        path: "settings/organization-settings",
        element: <OrganizationSettings />,
    },
    {
        path: "settings/domains",
        element: <OrganizationDomains />,
    },
    {
        path: "settings/users",
        element: <UsersSettings />,
    },
];

export { settingsRoutes };
